import { IPermission } from "../../pages/private/Permissions/Permissions";
import { IAreaExpertise } from "./areaExpertise";
import { IBeehive } from "./beehive";
import { IBeehiveAlert } from "./beehiveAlerts";
import { IBeehiveAlertsConfiguration } from "./beehiveAlertsConfiguration";
import { IBeehiveStats } from "./beehiveStats";
import { ICustomPaginationProps } from "./pagination";
import { IRole } from "./roles";
import { IUser } from "./user";

export enum ACTIONS {
    EDIT = "edit",
    DELETE = "delete",
    INFO = "info",
    ADD = "add",
    READ = "read",
    PASSWORD = "change-password",
    EXPORT = "export",
    EXPORT_DATA = "export-data",
    PENDING = "pending"
}
export type Row = (
    IUser |
    IBeehive |
    IBeehiveAlert |
    IBeehiveAlertsConfiguration |
    IBeehiveStats |
    IAreaExpertise |
    IRole |
    IPermission
) & { actions: { type: ACTIONS, message: string }[] }

export type Order = 'asc' | 'desc';

export interface ICustomTableProps {
    headcells: { key: string, label: string }[],
    rows: Row[],
    pagination?: ICustomPaginationProps;
    onIconActionClicked?: (action: ACTIONS, data: any) => void;
    hasCustomStyles?: boolean;
    isEditPermitted?: boolean;
    isDeletePermitted?: boolean;
}